const defaultTheme = {
    sizes: {
        appMenu: 220,
    },
};

export default defaultTheme;
